import React from 'react';
import PropTypes from 'prop-types';
import { ErrorBoundary } from './ErrorBoundary';
import { useError } from '@/contexts/ErrorContext';
import { NetworkError } from '@/layout/common-pages';

/**
 * Combined Error Boundary with Context
 * Catches both:
 * 1. JavaScript errors (via Error Boundary)
 * 2. API/Network errors (via Error Context)
 *
 * This is the recommended component to use in your app
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components
 * @return {JSX.Element} Error boundary wrapper with context
 */
export const ErrorBoundaryWithContext = ({ children }) => {
  const { sosError, clearError } = useError();

  // If context has an error, show it (takes precedence over boundary errors)
  if (sosError) {
    return (
      <NetworkError
        error={sosError}
        onRetry={() => {
          clearError();
          // Could also trigger a page reload or navigation
        }}
      />
    );
  }

  // Wrap children in error boundary to catch JS errors
  return <ErrorBoundary>{children}</ErrorBoundary>;
};

ErrorBoundaryWithContext.propTypes = {
  children: PropTypes.node.isRequired,
};
